import { Flex, VStack } from "@chakra-ui/react";
import { useParams } from "react-router-dom";

import { useSsoAccountActivation } from "modules/authentication/infrastructure/useSsoAccountActivation";
import { useGetUserSsoTempAppointment } from "modules/appointment/infrastructure/useGetUserSsoTempAppointment";

import { ChakraText } from "components/ChakraText";
import { MainPageButton } from "components/MainPageButton";
import { ErrorWidget, SuccessWidget } from "components/Widgets";

import { TokenExpiredErrorBoundary } from "../Commons/TokenExpiredErrorBoundary";
import { AdditionalInformation } from "../RegistrationConfirmationPage/AdditionalInformation";

const RegistrationConfirmationSsoUserPageThrowable = () => {
  const { ssoToken } = useParams<{
    ssoToken: string;
  }>();

  const { data } = useSsoAccountActivation(ssoToken);

  const { data: appointment } = useGetUserSsoTempAppointment(
    data?.id!,
    data?.token!
  );

  return (
    <>
      <SuccessWidget>
        <VStack spacing={0} ml={6} justifyContent="center">
          <ChakraText fontSize={{ base: "xl", md: "2xl" }}>
            Dziękujemy za rejestrację w naszym systemie.
          </ChakraText>
          <ChakraText fontSize={{ base: "xl", md: "2xl" }}>
            Nowe konto zostało zweryfikowane poprawnie.
          </ChakraText>
        </VStack>
      </SuccessWidget>
      {appointment?.appointmentId ? (
        <AdditionalInformation appointmentId={appointment.appointmentId} />
      ) : (
        <Flex my={10} w="70%" mx="auto" justifyContent="center">
          <MainPageButton />
        </Flex>
      )}
    </>
  );
};

const RegistrationConfirmationSsoUserPage = () => {
  const { ssoToken } = useParams<{
    ssoToken: string;
  }>();

  if (ssoToken === "error") {
    return (
      <>
        <ErrorWidget>
          <ChakraText fontSize={{ base: "xl", md: "2xl" }} alignSelf="center">
            Nie udało się zarejestrować konta.
          </ChakraText>
        </ErrorWidget>
        <Flex my={10} w="70%" mx="auto" justifyContent="center">
          <MainPageButton />
        </Flex>
      </>
    );
  }

  return (
    <TokenExpiredErrorBoundary>
      <RegistrationConfirmationSsoUserPageThrowable />
    </TokenExpiredErrorBoundary>
  );
};

export default RegistrationConfirmationSsoUserPage;
